"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSmallDimension = exports.StyledButtonFilter = exports.StyledButtonTabText = exports.StyledButtonTabIcon = exports.StyledButtonTab = exports.getButtonVerticalTabStyles = exports.getButtonTabStyles = exports.StyledButtonIcon = exports.ButtonIconStyles = exports.StyledButtonText = exports.StyledButtonLink = exports.getButtonDangerStyles = exports.StyledButtonDanger = exports.StyledButtonSecondary = exports.getButtonSecondaryStyles = exports.StyledButtonOrange = exports.StyledButtonMain = exports.StyledButtonRightChild = exports.StyledButtonLeftChild = exports.StyledButtonChild = void 0;
var styled_components_1 = require("styled-components");
var common_1 = require("../../common/common");
var theme_1 = require("../../utils/theme");
var types_1 = require("../../utils/types");
var ApIcon_1 = require("../ApIcon");
exports.StyledButtonChild = styled_components_1.default.span({
    display: 'inline-flex',
    whiteSpace: 'nowrap',
});
exports.StyledButtonLeftChild = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
exports.StyledButtonRightChild = styled_components_1.default.span({
    display: 'inline-flex',
    whiteSpace: 'nowrap',
});
exports.StyledButtonMain = styled_components_1.default.button(__assign(__assign({ ':hover:enabled': {
        background: theme_1.colors.green2,
    }, ':focus:enabled': {
        background: theme_1.colors.green2,
    }, ':active:enabled': {
        background: theme_1.colors.green3,
    } }, common_1.commonButtonStyles), { color: theme_1.colors.white, i: {
        fill: theme_1.colors.white,
    }, minWidth: '64px', padding: "0px " + theme_1.scaffolding.md, svg: {
        fill: theme_1.colors.white,
    } }), function (_a) {
    var disabled = _a.disabled, iconName = _a.iconName, small = _a.small;
    return (__assign(__assign(__assign({}, common_1.getCommonDisabled(disabled)), { background: disabled ? theme_1.colors.grey4 : theme_1.colors.green1 }), exports.getSmallDimension(small, iconName)));
});
exports.StyledButtonOrange = styled_components_1.default.button(__assign(__assign({}, common_1.commonButtonStyles), { color: theme_1.colors.white, ':hover:enabled': {
        background: theme_1.colors.amber700,
    }, ':focus:enabled': {
        background: theme_1.colors.amber700,
    }, ':active:enabled': {
        background: theme_1.colors.amber800,
    }, i: {
        color: theme_1.colors.white,
    }, svg: {
        fill: theme_1.colors.white,
    }, padding: "0 " + theme_1.scaffolding.md }), function (_a) {
    var disabled = _a.disabled, iconName = _a.iconName, small = _a.small;
    return (__assign(__assign(__assign({}, common_1.getCommonDisabled(disabled)), { background: disabled ? theme_1.colors.grey300 : theme_1.colors.amber600 }), exports.getSmallDimension(small, iconName)));
});
exports.getButtonSecondaryStyles = function (disabled, theme) {
    var _a;
    var buttonSecondaryStyles = (_a = {},
        _a[types_1.LIGHT] = {
            color: disabled ? theme_1.colors.grey400 : theme_1.colors.green600,
            border: '1px solid',
            borderColor: disabled ? theme_1.colors.grey400 : theme_1.colors.green700,
            ':hover:enabled': {
                background: theme_1.colors.green50,
                color: theme_1.colors.green700,
            },
            ':focus:enabled': {
                background: theme_1.colors.green50,
                color: theme_1.colors.green700,
            },
            ':active:enabled': {
                background: theme_1.colors.green100,
                color: theme_1.colors.green700,
            },
            i: {
                color: disabled ? theme_1.colors.grey400 : theme_1.colors.green600,
            },
            svg: {
                fill: disabled ? theme_1.colors.grey400 : theme_1.colors.green600,
            },
        },
        _a[types_1.DARK] = {
            color: disabled ? theme_1.colors.grey500 : theme_1.colors.white,
            border: '1px solid',
            background: 'transparent',
            borderColor: disabled ? theme_1.colors.grey500 : theme_1.colors.white,
            ':hover:enabled': {
                background: 'rgba(255, 255, 255, 0.15)',
                color: theme_1.colors.white,
            },
            ':focus:enabled': {
                background: 'rgba(255, 255, 255, 0.15)',
                color: theme_1.colors.white,
            },
            ':active:enabled': {
                background: 'rgba(255, 255, 255, 0.4)',
                color: theme_1.colors.white,
            },
            i: {
                color: disabled ? theme_1.colors.grey500 : theme_1.colors.white,
            },
            svg: {
                fill: disabled ? theme_1.colors.grey500 : theme_1.colors.white,
            },
        },
        _a);
    return buttonSecondaryStyles[theme];
};
exports.StyledButtonSecondary = styled_components_1.default.button(__assign(__assign({}, common_1.commonButtonStyles), { background: theme_1.colors.transparent, padding: "0 " + theme_1.scaffolding.md }), function (_a) {
    var disabled = _a.disabled, iconName = _a.iconName, theme = _a.theme, small = _a.small;
    return (__assign(__assign(__assign({}, common_1.getCommonDisabled(disabled)), exports.getButtonSecondaryStyles(disabled, theme)), exports.getSmallDimension(small, iconName)));
});
exports.StyledButtonDanger = styled_components_1.default.button(__assign(__assign({}, common_1.commonButtonStyles), { background: theme_1.colors.transparent, padding: "0 " + theme_1.scaffolding.md }), function (_a) {
    var disabled = _a.disabled, iconName = _a.iconName, theme = _a.theme, small = _a.small;
    return (__assign(__assign(__assign(__assign({}, common_1.getCommonDisabled(disabled)), exports.getButtonDangerStyles(disabled, theme)), exports.getSmallDimension(small, iconName)), { i: {
            color: disabled ? theme_1.colors.grey400 : theme_1.colors.red700,
        }, svg: {
            fill: disabled ? theme_1.colors.grey400 : theme_1.colors.red700,
        } }));
});
exports.getButtonDangerStyles = function (disabled, theme) {
    var _a;
    var buttonDangerStyles = (_a = {},
        _a[types_1.LIGHT] = {
            border: "1px solid " + (disabled ? theme_1.colors.grey400 : theme_1.colors.red500),
            color: disabled ? theme_1.colors.grey400 : theme_1.colors.red700,
            ':hover:enabled': {
                background: theme_1.colors.red50,
            },
            ':focus:enabled': {
                background: theme_1.colors.red50,
            },
            ':active:enabled': {
                background: theme_1.colors.pink3,
                color: theme_1.colors.red2,
                i: {
                    color: theme_1.colors.red2,
                },
                svg: {
                    fill: theme_1.colors.red2,
                },
            },
        },
        _a[types_1.DARK] = {
            border: "1px solid " + (disabled ? theme_1.colors.grey400 : theme_1.colors.red300),
            color: disabled ? theme_1.colors.grey500 : theme_1.colors.red500,
            background: 'transparent',
            ':hover:enabled': {
                background: 'rgba(252, 165, 165, 0.1)',
            },
            ':focus:enabled': {
                background: 'rgba(252, 165, 165, 0.1)',
            },
            ':active:enabled': {
                background: 'rgba(252, 165, 165, 0.2)',
                color: theme_1.colors.red500,
                i: {
                    color: theme_1.colors.red500,
                },
                svg: {
                    fill: theme_1.colors.red500,
                },
            }
        },
        _a);
    return buttonDangerStyles[theme];
};
exports.StyledButtonLink = styled_components_1.default.a(__assign({ ':active': {
        background: theme_1.colors.lightGreen3,
        color: theme_1.colors.green1,
    }, ':focus': {
        color: theme_1.colors.green1,
    }, background: theme_1.colors.transparent }, common_1.commonButtonStyles), function (_a) {
    var disabled = _a.disabled;
    return (__assign(__assign({ ':hover': {
            background: disabled ? theme_1.colors.transparent : theme_1.colors.lightGreen1,
        } }, common_1.getCommonDisabled(disabled)), { color: disabled ? theme_1.colors.grey3 : theme_1.colors.green1 }));
});
exports.StyledButtonText = styled_components_1.default.a(__assign({ ':active': {
        color: theme_1.colors.green1,
        textDecoration: 'underline',
    }, ':focus': {
        color: theme_1.colors.green1,
    }, background: theme_1.colors.transparent }, common_1.commonButtonStyles), function (_a) {
    var disabled = _a.disabled;
    return (__assign(__assign({ ':hover': {
            color: disabled ? theme_1.colors.grey3 : theme_1.colors.green2,
            textDecoration: disabled ? 'none' : 'underline',
        } }, common_1.getCommonDisabled(disabled)), { color: disabled ? theme_1.colors.grey3 : theme_1.colors.green1 }));
});
exports.ButtonIconStyles = styled_components_1.default.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border: 6px solid transparent;\n  width: ", "px;\n  height: ", "px;\n  border-radius: 50%;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n  cursor: pointer;\n  outline: none;\n  :disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n  i {\n    font-size: ", "px;\n  }\n  svg {\n    width: ", "px;\n    height: ", "px;\n  }\n  ", "\n    ", "\n\n"], ["\n  border: 6px solid transparent;\n  width: ", "px;\n  height: ", "px;\n  border-radius: 50%;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n  cursor: pointer;\n  outline: none;\n  :disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n  i {\n    font-size: ", "px;\n  }\n  svg {\n    width: ", "px;\n    height: ", "px;\n  }\n  ",
    "\n    ",
    "\n\n"])), function (_a) {
    var small = _a.small;
    return (small ? 32 : 40);
}, function (_a) {
    var small = _a.small;
    return (small ? 32 : 40);
}, theme_1.colors.grey5, function (_a) {
    var small = _a.small;
    return (small ? 20 : 24);
}, function (_a) {
    var small = _a.small;
    return (small ? 20 : 24);
}, function (_a) {
    var small = _a.small;
    return (small ? 20 : 24);
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return theme === types_1.DARK
        ? styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          :hover:enabled {\n            background-color: rgba(255, 255, 255, 0.2);\n          }\n          :focus:enabled {\n            background-color: rgba(255, 255, 255, 0.2);\n          }\n          :active:enabled {\n            background-color: rgba(255, 255, 255, 0.4);\n          }\n          i {\n            color: ", ";\n          }\n          svg {\n            fill: ", ";\n          }\n        "], ["\n          :hover:enabled {\n            background-color: rgba(255, 255, 255, 0.2);\n          }\n          :focus:enabled {\n            background-color: rgba(255, 255, 255, 0.2);\n          }\n          :active:enabled {\n            background-color: rgba(255, 255, 255, 0.4);\n          }\n          i {\n            color: ", ";\n          }\n          svg {\n            fill: ", ";\n          }\n        "])), disabled ? theme_1.colors.grey300 : theme_1.colors.white, disabled ? theme_1.colors.grey300 : theme_1.colors.white) : styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          :hover:enabled {\n            background-color: ", ";\n            color: ", ";\n            fill: ", ";\n          }\n          :focus:enabled {\n            background-color: ", ";\n            color: ", ";\n            fill: ", ";\n          }\n          :active:enabled {\n            background-color: ", ";\n            color: ", ";\n            fill: ", ";\n          }\n          i {\n            color: ", ";\n          }\n          svg {\n            fill: ", ";\n          }\n        "], ["\n          :hover:enabled {\n            background-color: ", ";\n            color: ", ";\n            fill: ", ";\n          }\n          :focus:enabled {\n            background-color: ", ";\n            color: ", ";\n            fill: ", ";\n          }\n          :active:enabled {\n            background-color: ", ";\n            color: ", ";\n            fill: ", ";\n          }\n          i {\n            color: ", ";\n          }\n          svg {\n            fill: ", ";\n          }\n        "])), theme_1.colors.green50, theme_1.colors.green700, theme_1.colors.green700, theme_1.colors.green50, theme_1.colors.green700, theme_1.colors.green700, theme_1.colors.green100, theme_1.colors.green700, theme_1.colors.green700, disabled ? theme_1.colors.grey500 : theme_1.colors.green600, disabled ? theme_1.colors.grey500 : theme_1.colors.green600);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        cursor: not-allowed;\n      "], ["\n        cursor: not-allowed;\n      "])));
});
exports.StyledButtonIcon = styled_components_1.default(exports.ButtonIconStyles)(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
exports.getButtonTabStyles = function (disabled, theme, isSelected, vertical) {
    var _a;
    if (vertical) {
        return exports.getButtonVerticalTabStyles(disabled, theme, isSelected);
    }
    var buttonTabStyles = (_a = {},
        _a[types_1.LIGHT] = {
            ':hover:enabled': {
                backgroundColor: theme_1.colors.green50,
                color: theme_1.colors.grey700,
            },
            ':hover:enabled:before': {
                borderBottomColor: theme_1.colors.green500,
                borderBottomWidth: isSelected ? '2px' : '1px',
                width: '100%'
            },
            ':focus:enabled': {
                backgroundColor: theme_1.colors.green50,
                color: theme_1.colors.grey700,
            },
            ':focus:enabled:before': {
                borderBottomColor: theme_1.colors.green500,
                borderBottomWidth: isSelected ? '2px' : '1px',
                width: '100%'
            },
            ':active:enabled': {
                backgroundColor: theme_1.colors.green100,
                color: theme_1.colors.grey700,
                ':before': {
                    borderBottomColor: theme_1.colors.green1,
                    width: '100%',
                },
            },
            ':before': {
                borderBottomColor: disabled ? theme_1.colors.grey400 : theme_1.colors.green500,
                width: isSelected ? '100%' : '0%',
            },
            color: disabled ? theme_1.colors.grey400 : theme_1.colors.grey500,
            fill: disabled ? theme_1.colors.grey400 : theme_1.colors.grey700,
        },
        _a[types_1.DARK] = {
            ':hover:enabled': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
            ':hover:enabled:before': {
                borderBottomColor: theme_1.colors.white,
                borderBottomWidth: isSelected ? '2px' : '1px',
                width: '100%'
            },
            ':focus:enabled': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
            ':focus:enabled:before': {
                borderBottomColor: theme_1.colors.white,
                borderBottomWidth: isSelected ? '2px' : '1px',
                width: '100%'
            },
            ':active:enabled': {
                color: theme_1.colors.white,
            },
            ':before': {
                borderBottomColor: disabled ? theme_1.colors.grey500 : theme_1.colors.white,
                width: isSelected ? '100%' : '0%',
            },
            height: '48px',
            fontWeight: isSelected ? 500 : 400,
            color: isSelected && !disabled ? theme_1.colors.white : (disabled ? theme_1.colors.grey500 : theme_1.colors.grey300),
            fill: isSelected && !disabled ? theme_1.colors.white : (disabled ? theme_1.colors.grey500 : theme_1.colors.grey300),
        },
        _a);
    return buttonTabStyles[theme];
};
exports.getButtonVerticalTabStyles = function (disabled, theme, isSelected) {
    var _a;
    var buttonVerticalTabStyles = (_a = {},
        _a[types_1.LIGHT] = {
            ':hover:enabled': {
                backgroundColor: theme_1.colors.green50,
                color: theme_1.colors.grey700,
            },
            ':hover:enabled:before': {
                borderRightColor: theme_1.colors.green500,
                borderRightWidth: isSelected ? '2px' : '1px',
                height: '100%'
            },
            ':focus:enabled': {
                backgroundColor: theme_1.colors.green50,
                color: theme_1.colors.grey700,
            },
            ':focus:enabled:before': {
                borderRightColor: theme_1.colors.green500,
                borderRightWidth: isSelected ? '2px' : '1px',
                height: '100%'
            },
            ':active:enabled': {
                backgroundColor: theme_1.colors.green100,
                color: theme_1.colors.grey700,
                ':before': {
                    borderRightColor: theme_1.colors.green1,
                    height: '100%',
                },
            },
            ':before': {
                borderRightColor: disabled ? theme_1.colors.grey400 : theme_1.colors.green500,
                height: isSelected ? '100%' : '0%',
            },
            fontWeight: isSelected ? 500 : 400,
            color: disabled ? theme_1.colors.grey400 : theme_1.colors.grey700,
            svg: {
                fill: disabled ? theme_1.colors.grey400 : theme_1.colors.grey700
            }
        },
        _a[types_1.DARK] = {
            ':hover:enabled': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
            ':hover:enabled:before': {
                borderRightColor: theme_1.colors.white,
                borderRightWidth: isSelected ? '2px' : '1px',
                height: '100%'
            },
            ':focus:enabled': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
            ':focus:enabled:before': {
                borderRightColor: theme_1.colors.white,
                borderRightWidth: isSelected ? '2px' : '1px',
                height: '100%'
            },
            ':active:enabled': {
                color: theme_1.colors.white,
                backgroundColor: 'transparent',
            },
            ':hover:enabled:active': {
                backgroundColor: 'transparent',
            },
            ':focus:enabled:active': {
                backgroundColor: 'transparent',
            },
            ':before': {
                borderRightColor: disabled ? theme_1.colors.grey500 : theme_1.colors.white,
                height: isSelected ? '100%' : '0%',
            },
            fontWeight: isSelected ? 500 : 400,
            color: isSelected && !disabled ? theme_1.colors.white : (disabled ? theme_1.colors.grey500 : theme_1.colors.grey300),
            svg: {
                fill: isSelected && !disabled ? theme_1.colors.white : (disabled ? theme_1.colors.grey500 : theme_1.colors.grey300),
            },
        },
        _a);
    return buttonVerticalTabStyles[theme];
};
exports.StyledButtonTab = styled_components_1.default.button({}, function (_a) {
    var icon = _a.icon, vertical = _a.vertical;
    return (vertical ? __assign(__assign({ ':before': __assign({ borderRightColor: theme_1.colors.transparent, borderRightStyle: 'solid', borderRightWidth: '2px', content: "''", height: "calc(100%)", top: '50%', position: 'absolute', right: '0px', transform: 'translateY(-50%)' }, common_1.commonTransition) }, common_1.commonButtonStyles), { minWidth: '192px', maxWidth: '280px', height: '48px', background: theme_1.colors.transparent, padding: icon ? '0 20px 0 32px' : '0 32px', justifyContent: 'space-between' }) : __assign(__assign({ ':before': __assign({ borderBottomColor: theme_1.colors.transparent, borderBottomStyle: 'solid', borderBottomWidth: '2px', content: "''", height: "calc(100%)", left: '50%', position: 'absolute', top: '0px', transform: 'translateX(-50%)' }, common_1.commonTransition) }, common_1.commonButtonStyles), { minWidth: '64px', height: '56px', background: theme_1.colors.transparent, padding: '0px 12px' }));
}, function (_a) {
    var disabled = _a.disabled, isSelected = _a.isSelected, theme = _a.theme, vertical = _a.vertical;
    return (__assign(__assign({ fontWeight: isSelected ? 500 : 400 }, exports.getButtonTabStyles(disabled, theme, isSelected, vertical)), common_1.getCommonDisabled(disabled)));
});
exports.StyledButtonTabIcon = styled_components_1.default(ApIcon_1.ApIcon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-left: 8px;\n"], ["\n  margin-left: 8px;\n"])));
exports.StyledButtonTabText = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  min-width: 64px;  \n  max-width: 190px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  min-width: 64px;  \n  max-width: 190px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
exports.StyledButtonFilter = styled_components_1.default.button(__assign(__assign({}, common_1.commonButtonStyles), { ':hover:enabled': {
        color: theme_1.colors.green1,
    }, background: theme_1.colors.transparent, borderRadius: theme_1.scaffolding.md, borderStyle: 'solid', borderWidth: '1px', padding: "0px " + theme_1.scaffolding.md }), function (_a) {
    var isSelected = _a.isSelected, disabled = _a.disabled;
    return (__assign(__assign(__assign({}, common_1.getCommonFocus(types_1.LIGHT)), common_1.getCommonDisabled(disabled)), { borderColor: isSelected ? theme_1.colors.green1 : theme_1.colors.grey3, color: disabled ? theme_1.colors.grey3 : theme_1.colors.grey8 }));
});
exports.getSmallDimension = function (small, iconName) {
    return small ?
        {
            height: '32px',
            padding: '0px 12px',
            lineHeight: '16px',
            fontSize: '13px',
            paddingLeft: iconName ? '8px' : '12px',
            '.ap-icon': {
                marginRight: '4px',
                width: '16px',
            },
        }
        : {
            paddingLeft: iconName ? '8px' : '16px',
        };
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=styles.js.map